import {useState} from 'react';


export function useFormValidation(form,requiredFields) {
  const [validated,setValidated] = useState(true);

  function checkValidation() {
    const isValid = requiredFields.reduce((result,item) => !form[item] ? false : result,true);
    return isValid;
  }

  return {validated,setValidated,checkValidation};
}
